module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-upload-single"
    }
  }, [_c('hrms-dropzone', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "fileNameQuery": 'XXXXXXXX.jpg',
      "data-vv-value-path": "resultFileName",
      "data-vv-as": 'dropzone',
      "data-vv-name": 'dropzone',
      "name": 'dropzone',
      "has-error": _vm.errors.has('dropzone')
    },
    model: {
      value: (_vm.fileName),
      callback: function($$v) {
        _vm.fileName = $$v
      },
      expression: "fileName"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dropzone')),
      expression: "errors.has('dropzone')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dropzone')))]), _vm._v("\n  " + _vm._s(_vm.fileName) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5470cd31!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoUploadSingle.vue
// module id = 3765
// module chunks = 1